const WAT_OFFSET_MS = 60 * 60 * 1000;

export function effectiveSubscriptionEnd(recordedEnd: Date | string) {
  const end = recordedEnd instanceof Date ? recordedEnd : new Date(recordedEnd);
  const shifted = new Date(end.getTime() + WAT_OFFSET_MS);
  return new Date(Date.UTC(
    shifted.getUTCFullYear(),
    shifted.getUTCMonth(),
    shifted.getUTCDate(),
    17,
  ));
}